// src/components/ui/WhatsAppButton.jsx (Simplificado)
import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "5214142196366";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
const WHATSAPP_MESSAGE = "Hola, me gustaría obtener más información sobre Casa El Gavillero.";

export default function WhatsAppButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    window.open(`${WHATSAPP_URL}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`, "_blank");
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          transition={{ duration: 0.3 }}
          onClick={handleClick}
          className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg bg-[#25D366] hover:bg-[#20b858] text-white transition-all duration-300 hover:scale-105 active:scale-95 group"
          aria-label="Chat por WhatsApp"
        >
          <MessageCircle size={28} strokeWidth={2} />
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
          
          {/* Tooltip flotante */}
          <span className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-white dark:bg-neutral-900 text-foreground text-xs font-light px-3 py-2 rounded-lg shadow-lg border border-border whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            Chatea con nosotros
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}